<template>
    <div class="line-top">
        <div class="table-padrao">
            <table class="zebra" data-tablesaw-mode="swipe">
                <thead>
                    <tr v-if="ids.length > 0" class="sem-cor">
                        <td colspan="10"><h2 class="interno">Escolha como voce deseja baixar as imagens.</h2></td>
                    </tr>
                    <tr v-if="ids.length > 0">
                        <th colspan="2" style="background-color: #EAEDF1;">
                            <div class="tabela-fotos">
                                <form class="form-padrao">
                                    <div class="relative-form">
                                        <select class="custom" v-model="tipo">
                                            <option value="">Escolha o formato...</option>
                                            <option value="jpg">JPG</option>
                                            <option value="png">PNG</option>
                                        </select>
                                    </div>
                                </form>
                            </div>
                        </th>
                        <th colspan="2" style="background-color: #EAEDF1;">
                            <div class="tabela-fotos">
                                <form class="form-padrao">
                                    <div class="relative-form">
                                        <select class="select custom" v-model="acao">
                                            <option value="">Escolha o que fazer...</option>
                                            <option value="baixar">Baixar</option>
                                            <option value="email">Enviar por email</option>
                                        </select>
                                    </div>
                                </form>
                            </div>
                        </th>
                        <th colspan="2" style="background-color: #EAEDF1;">
                            <div class="tabela-fotos" v-if="acao === 'email'">
                                <form class="form-padrao">
                                    <div class="relative-form">
                                        <input type="text" style="width: 100%" v-model="email" placeholder="Informe o email"/>
                                    </div>
                                </form>
                            </div>
                        </th>
                        <th colspan="2" style="text-align: center; background-color: #EAEDF1; color: black">Itens selecionados: {{ids.length}}</th>
                        <th style="background-color: #EAEDF1; text-align: center">
                            <button v-if="acao && tipo" class="btn-padrao" :disabled="acao === 'email' && (!email || submiting)" @click="post">
                                {{acao === 'baixar' ? 'Baixar' : 'Enviar'}}
                            </button>
                        </th>
                    </tr>
                    <tr>
                        <th style="width: 50px; text-align:center;">Seleção</th>
                        <th style="width: 100px">Família</th>
                        <th style="width: 100px">Grupo</th>
                        <th style="width: 100px">Sub-grupo</th>
                        <th style="width: 100px">Ref. Principal</th>
                        <th style="width: 100px">Ref. Produto</th>
                        <th style="width: 100px">Arquivo (.png)</th>
                        <th style="width: 100px">Arquivo (.jpg)</th>
                        <th style="width: 100px">Pré-visualizar</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="foto in fotos">
                        <th>
                            <div class="relative-form">
                                <input type="checkbox" :name="foto.id" :id="foto.id" class="css-checkbox" @click="registrar" :checked="checkId(foto.id)">
                                <label :for="foto.id" class="css-label"></label>
                            </div>
                        </th>
                        <th>
                            {{foto.familia ?  foto.familia.titulo : ''}}
                        </th>
                        <th>
                             {{foto.grupo ?  foto.grupo.titulo : ''}}
                        </th>
                        <th>
                            {{foto.subgrupo ?  foto.subgrupo.titulo : ''}}
                        </th>
                        <th>
                            {{foto.produto ?  foto.produto.referencia_principal : ''}}
                        </th>
                        <th>
                            {{foto.produto ?  foto.produto.referencia : ''}}
                        </th>
                        <th style="text-align: center">
                            <i class="fa fa-check" v-if="foto.nome_psd" style="color: green"></i>
                            <i class="fa fa-times" v-else style="color: red"></i>
                        </th>
                        <th style="text-align: center">
                            <i class="fa fa-check" v-if="foto.nome_jpg" style="color: green"></i>
                            <i class="fa fa-times" v-else style="color: red"></i>
                        </th>
                        <th>
                            <div class="pre-visualizacao" v-if="foto.urlpath_jpg">
                                <a data-fancybox="gallery" :href="foto.urlpath_jpg">
                                    <i class="icon-lupa"></i>
                                    <div class="box-imagem">
                                        <img :src="foto.urlpath_jpg" :alt="foto.produto.referencia_principal">
                                    </div>
                                </a>
                            </div>
                            <div v-else style="text-align: center">
                                <i class="icon-delete"></i>
                            </div>
                        </th>
                    </tr>
                </tbody>
                <tfoot v-if="!loading">
                     <tr>
                        <th colspan="8">
                            <infinite-loading ref="infinite" @infinite="loadFotos">
                                <div slot="spinner">
                                    <vue-element-loading :active="true" spinner="bar-fade-scale"/>
                                </div>
                                <div style="font-size: 0.9em" slot="no-results">
                                    <small v-if="fotos.length === 0">Nenhum resultado encontrado</small>
                                    <small v-else>Total de registros carregados: {{fotos.length}}</small>
                                </div>
                                <div style="font-size: 0.9em" slot="no-more">
                                    <small>Total de registros carregados: {{fotos.length}}</small>
                                </div>
                            </infinite-loading>
                        </th>
                     </tr>
                </tfoot>
            </table>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import formatMixin from '../../../../../../../../../resources/assets/js/mixins/formatMixin';

    export default
    {
        mixins: [formatMixin],
        data() {
            return {
                fotos: [],
                ids: [],
                email: '',
                acao: '',
                tipo: '',
                request: {page: 1},
                loading: false,
                submiting: false,
                root: ROOT_URL,
                app: APP_URL
            };
        },
        computed: {
            ...mapGetters({hasRole: 'roles/hasRole'})
        },
        methods: {
            loadFotos($state = { loaded() {}, complete() {} })
            {
                this.axios(this.app + '/api/imagens/fotos', {params: this.request}).then((retorno) =>
                {
                    if (retorno.data.data.length > 0)
                    {
                        this.fotos = this.fotos.concat(retorno.data.data);
                        this.request.page++;
                        $state.loaded();
                    }
                    else
                    {
                        $state.complete();
                    }

                    if (this.loading)
                    {
                        this.loading = false;
                    }

                    this.$forceUpdate();
                });
            },
            buscar(filtros)
            {
                this.request.page = 1;
                this.request = this.extend(this.request, filtros);
                this.loading = true;
                this.fotos = [];
                this.loadFotos();
            },
            registrar(event)
            {
                if (event.target.checked)
                {
                    this.ids.push(parseInt(event.target.id));
                }
                else
                {
                    this.ids.splice(this.ids.indexOf(event.target.id), 1);
                }
            },
            checkId(id)
            {
                return this.ids.includes(parseInt(id));
            },
            post()
            {
                this.submiting = true;
                if (this.acao === 'baixar')
                {
                    this.$toasted.show('Aguarde um instante, você será redirecionado para a página de download!', {type: 'info', duration: 3000, onComplete: this.submitForm()});
                }
                else
                {
                    this.$toasted.show('Aguarde um instante, estamos tentando enviar o email!', {type: 'info', duration: 5000});
                    this.axios.post(this.app + '/api/imagens/enviar-email', {ids: this.ids, tipo: this.tipo, email: this.email}).then((retorno) =>
                    {
                        if (retorno.data.status === 'OK')
                        {
                            this.$toasted.show('Um link para download foi enviado para o email: '+this.email+'!', {type: 'success', action: {text: 'X', onClick: (e, toastObject) => { toastObject.goAway(0)}}});
                        }
                        else
                        {
                            this.$toasted.show('Não foi possível enviar o email, tente outro formato!', {type: 'error', action: {text: 'X', onClick: (e, toastObject) => { toastObject.goAway(0)}}});
                        }

                        this.submiting = false;
                    });
                }
            },
            submitForm()
            {
                let form = document.createElement("form");
                form.target = "_blank";
                form.method = "POST";
                form.action = this.app + '/api/imagens/preparar';

                let token =  document.querySelector('meta[name="csrf-token"]').getAttribute('content');

                let csrf = this.createField('input', '_token', 'hidden', token);
                let ids = this.createField('input', 'ids', 'hidden', this.ids);
                let tipo = this.createField('input', 'tipo', 'hidden', this.tipo);

                form.appendChild(csrf);
                form.appendChild(ids);
                form.appendChild(tipo);

                document.body.appendChild(form);

                form.submit();

                this.submiting = false;
            },
            createField(element, name, type, value)
            {
                let field = document.createElement(element);
                field.type = type;
                field.name = name;
                field.value = value;

                return field;
            }
        },
        mounted () {
            this.loading = true;
            this.loadFotos();
        }
    };

</script>